<template lang="pug">
v-dialog(v-if="showDialog" v-model="showDialog" max-width="560")
  v-card(rounded="lg")
    v-card-title.px-4
      v-spacer
      h6.ml-10 {{ $t('delete_task') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider.mb-6

    .px-6
      .s1 {{ $t('delete_task_confirmation_1') }}
      .mt-4.p1 {{ $t('delete_task_confirmation_2') }}
      .mt-4.p1.mb-16 {{ $t('click_confirm_to_proceed') }}
    v-divider.mb-2.mt-4
    
    v-card-actions.pb-4.px-6
      v-spacer
      v-btn.button-Aa-medium.px-4.primary400--text(@click="showDialog = false" text height=40) {{ $t('back') }}
      v-btn.button-Aa-medium.px-4(@click="deleteTask" :loading="isDeleting" color="danger500" depressed dark height=40) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'deleted', 'task'],
  data: () => ({
    isDeleting: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    deleteTask () {
      this.isDeleting = true
      this.$axios.delete(`/connect/${this.company.slug}/tasks/${this.task.id}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.task_remove_successfully')])
          this.showMessage(['success', 'Task remove successfully'])
          this.showDialog = false
          this.$router.push('/admin/connect/tasks')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_remove_task')])
        })
        .finally(() => {
          this.isDeleting = false
        })
    }
  }
}
</script>